<template>
  <div class="d-none">
      <input
        v-for="referenceEntry in transformedReference"
        :key="referenceEntry.name"
        type="hidden"
        :name="referenceEntry.name"
        :value="referenceEntry.value"
      />
  </div>
</template>

<script>
import { isUndefined, get, isFunction } from 'lodash-es'
export default {
  name: 'AdvReactiveFormInputManipulator',
  props: {
    stateGetterReference: {
      type: String,
      required: true
    }
  },
  computed: {
    transformedReference () {
      let transformedReferenceData = get(this.$store.getters, this.stateGetterReference)
      if (isUndefined(transformedReferenceData)) {
        throw new Error(`Unable to find getter "${this.fetchedGetter}"`)
      }
      if (isFunction(transformedReferenceData)) {
        transformedReferenceData = transformedReferenceData()
      }
      return transformedReferenceData
    }
  }
}
</script>
